<template>
  <v-card id="promotion-list">
    <!-- search -->
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">

        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.OrderStateCreate')"
          @click="createDialogShow()"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="orderStates"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >

      <template #[`item.name`]="{item}">
        {{ item.name }}
      </template>

      <template #[`item.code`]="{item}">
        {{ item.code }}
      </template>


      <template #[`item.contact`]="{item}">
        <span class="ma-0 pa-0">{{ item.contact }}</span>
      </template>

      <!-- actions -->
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">

          <!-- edit -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.OrderStateUpdate')"
                v-bind="attrs"
                v-on="on"
                @click="updateDialogShow(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>

          <!-- delete -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                :disabled="hasNotPermission('Permissions.OrderStateDelete')"
                v-on="on"
                @click="deletePopupShow(item.id, item.name)"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <delete-dialog @delete-confirmed="deleteOrderState" :label="deleteLabel" ref="deletePopup" />
    <order-state-form :label="'Редактирование состояния заказа'" :cancellation="updateDialogCancel" :show="updateDialog"
                  :save="updateOrderState"></order-state-form>
    <order-state-form :label="'Создание состояния заказа'" :cancellation="createDialogCancel" :show="createDialog"
                  :save="addOrderState"></order-state-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import DeleteDialog from '@/components/delete-dialog'
import OrderStateForm from './order-state-form.vue'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEyeOutline,
  mdiFacebook,
  mdiGooglePlay,
  mdiEmail,
  mdiApple,
  mdiInstagram,
  mdiWhatsapp,
  mdiPhone,
  mdiPencilOutline,
} from '@mdi/js'
import { hasPermission } from '@/helpers/index'

export default {
  components: { DeleteDialog, OrderStateForm },
  name: 'OrderStateList',
  data: () => ({
    createDialog: false,
    updateDialog: false,
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiGooglePlay,
      mdiApple,
      mdiEmail,
      mdiEyeOutline,
      mdiFacebook,
      mdiInstagram,
      mdiWhatsapp,
      mdiPhone,
    },
    deleteLabel: '',
    deleteMethod: null,
  }),
  computed: {
    ...mapFormHandlers('orderState', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('orderState', {
      orderStates: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Наименование', value: 'name' },
        { text: 'Код', value: 'code' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Состояние заказа'
    this.fetchOrderStates()
  },
  methods: {
    ...mapActions('orderState', {
      fetchOrderStates: 'fetchList',
      deleteOrderState: 'delete',
    }),
    ...mapActions('orderState/form', ['create', 'resetForm', 'fetchById', 'update']),
    hasNotPermission(val) {
      return !hasPermission(val)
    },
    deletePopupShow(id, name) {
      this.deleteLabel = 'Состояние заказа ' + name + ' будет удалено.'
      this.$refs.deletePopup.open(id)
    },
    async addOrderState() {
      await this.create()
      this.createDialog = false
    },
    async updateOrderState() {
      await this.update()
      this.updateDialog = false
    },
    createDialogShow() {
      this.createDialog = true
    },
    createDialogCancel() {
      this.createDialog = false
    },
    updateDialogCancel() {
      this.updateDialog = false
    },
    updateDialogShow(id) {
      this.fetchById(id)
      this.updateDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
